"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledUpdateCatalogOption = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledUpdateCatalogOption = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  border: 1px solid ${ui_components_1.baseColors.background100};
  border-radius: 4px;
  gap: ${({ theme }) => theme.spacing(2)};
  padding: ${({ theme }) => theme.spacing(2)};
  height: 180px;
  cursor: pointer;
  flex: 1;

  .MuiTypography-root {
    cursor: pointer;
  }

  &.update-catalog-option--selected {
    border-color: ${({ theme }) => theme.palette.primary.main};
  }

  &.update-catalog-option--disabled {
    border-color: ${ui_components_1.baseColors.background100};
    cursor: default;
  }

  .MuiFormControl-root {
    margin-top: auto;
  }

  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-text {
      font-size: 1.25rem;
    }

    & .title-check-icon {
      margin-right: 0;
    }
  }

  .hint {
    font-size: 1rem;
  }
`;
